import { styled } from '@mui/material'
import BasicDatagrid from '../../../components/shared/tables/BasicDatagrid'

const StyledBaseDatagrid = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '76vh'
  },
  '& .MuiDataGrid-cell': {
    /* overflow: hidden; */
    padding: '0.3rem 0',
    justifyContent: 'center',
    /* white-space: nowrap; */

    // background: 'chocolate',
    /* height: -webkit-fill-available; */
    maxHeight: 'none!important',
    height: 'auto!important',
    /* min-height: -webkit-fill-available!important; */
    whiteSpace: 'pre-wrap!important',
    '& .MuiDataGrid-cellContent': {
      // textTransform: 'lowercase!important',
      // background: 'red',
      width: '100%'
    },
    textAlign: 'center',
    '&:nth-of-type(3)': {
      textAlign: 'left!important'
    },
    '&:nth-of-type(4)': {
      textAlign: 'left!important'
    },
    '& .MuiDataGrid-columnHeadersInner': {
      '& .MuiDataGrid-columnHeader': {
        '&:nth-of-type(1)': {
          '& .MuiDataGrid-columnHeaderDraggableContainer': {
            '& div': {
              width: '100%!important',
              textAlign: 'center'
            }
          }
        }
      }
    }
  }
}))

export default StyledBaseDatagrid
